<template>
  <div id="calendar-sheet__video">
    <div class="" v-html="routedDay.videos[0].videoFile?._rendered" />
    <div
      id="calendar-sheet__video__title"
      class="video-preview-box__title text-black self-stretch grow p-[10px] text-center"
    >
      {{ routedDay.videos[0].title }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CalendarSheetVideo",
  computed: {
    ...mapGetters(["routedDay"]),
  },
};
</script>

<style scoped lang="css">
#calendar-sheet__video {
  @apply shadow-sm bg-white rounded-[6px] overflow-hidden text-center;

  & a {
    @apply no-underline w-min;
  }

  width: 199px;
  ::v-deep(iframe) {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;

    /* Very small screens :) */
    height: 112px;
    width: 100%;
  }
}

@media (min-width: 1024px) and (min-height: 768px) {
  #calendar-sheet__video {
    width: 270px;
    ::v-deep(iframe) {
      height: 152px;
    }
  }
}

@media (min-width: 1280px) and (min-height: 960px) {
  #calendar-sheet__video {
    width: 576px;
    ::v-deep(iframe) {
      height: 324px;
    }
  }
}

@media (min-width: 1600px) and (min-height: 1200px) {
  #calendar-sheet__video {
    width: 704px;
    ::v-deep(iframe) {
      height: 396px;
    }
  }
}
</style>
